import React from "react";
import { useSelector } from "react-redux";

import Modal from "./Modal";
import Loading from "components/Loader/Spinner";
import CustomSpinner from "components/Loader/CustomSpinner";
import {
  BACKGROUND_WALLET,
  MODAL_CLOSE,
  COMPLETE_TRANSACTION,
  FAILED_TRANSACTION,
} from "src/constants/images";
import { replaceFloatValue } from "utils/replaceFloatValue";

const Loader = ({ totalGbet }) => (
  <>
    <div className="header">
      <img
        src={BACKGROUND_WALLET.SOURCE}
        alt="background"
        className="background-wallet"
      />
      <h4 className="mb-2">Connected Wallet!.</h4>
      <p className="text">
        Total: <strong>{totalGbet} $GBET </strong>
      </p>
    </div>
    <div className="body loading">
      <CustomSpinner />
    </div>
    <div className="footer">
      <p className="py-2">
        {`Claiming`} {totalGbet} $GBET. <br /> Please wait.
      </p>
      <button disabled className="btn btn-outline-secondary close">
        Close
      </button>
    </div>
  </>
);

const Success = ({ onClick, totalGbet }) => (
  <>
    <span
      onClick={() => onClick()}
      onKeyPress={(e) => e.code == "Enter" && onClick()}
      className="close-modal"
    >
      <img src={MODAL_CLOSE.SOURCE} alt="close" />
    </span>
    <div className="header">
      <h4 className="mb-3">Congratulations !</h4>
      <p className="text">
        You successfully collected the accumulated $GBET.
        <br />
      </p>
    </div>
    <div className="body">
      <img
        src={COMPLETE_TRANSACTION.SOURCE}
        alt="transaction completed"
        className="d-block mx-auto my-3"
      />

      <button className="btn btn-outline-primary profile" onClick={onClick}>
        Close
      </button>
    </div>
  </>
);

const Cancel = ({ onClick }) => (
  <>
    <span
      onClick={() => onClick()}
      onKeyPress={(e) => e.code == "Enter" && onClick()}
      className="close-modal"
    >
      <img src={MODAL_CLOSE.SOURCE} alt="close" />
    </span>
    <div className="header">
      <h4 className="mb-2 me-2 ms-md-0">Oh No! Transaction Cancelled</h4>
      <p className="text my-3">We are unable to collect GBET.</p>
    </div>
    <div className="body">
      <span className="d-block mx-auto my-3 failed-transaction">
        <img
          src={FAILED_TRANSACTION.SOURCE}
          alt="transaction failed"
          className="mb-0"
        />
      </span>
      <button className="btn btn-outline-primary profile" onClick={onClick}>
        Close
      </button>
    </div>
  </>
);

const Error = ({ onClick, message }) => (
  <>
    <span
      onClick={() => onClick()}
      onKeyPress={(e) => e.code == "Enter" && onClick()}
      className="close-modal"
    >
      <img src={MODAL_CLOSE.SOURCE} alt="close" />
    </span>
    <div className="header">
      <h4 className="mb-2 me-2 ms-md-0">Oh No! Transaction failed</h4>
      <p className="text my-3">
        Could not claim $GBET due to transaction failure, please try again after
        sometime!
        <br />
        {message}
      </p>
    </div>
    <div className="body">
      <span className="d-block mx-auto my-3 failed-transaction">
        <img
          src={FAILED_TRANSACTION.SOURCE}
          alt="transaction failed"
          className="mb-0"
        />
      </span>
      <button className="btn btn-outline-primary profile" onClick={onClick}>
        Close
      </button>
    </div>
  </>
);

const MultiClaimModalLoader = ({ response, onClick, isVisible, totalGbet }) => {
  return (
    <Modal
      isVisible={isVisible}
      overlayClass="overlay"
      className="buying-modal card px-3 py-4"
    >
      {response.status === "success" ? (
        <Success onClick={onClick} totalGbet={totalGbet} />
      ) : response.status === "cancel" ? (
        <Cancel onClick={onClick} />
      ) : response.status === "error" ? (
        <Error onClick={onClick} message={response.msg} />
      ) : (
        <Loader totalGbet={totalGbet} />
      )}
    </Modal>
  );
};

export default MultiClaimModalLoader;
